<template>
    <modal @close="$emit('close')" :minWidthPx="mobile ? '320' : '650'">
        <div class="text-main-text text-left font-medium text-sm pb-10 px-5 md:px-10 ">
            <h2 class="text-lg md:text-2xl">Убедитесь, что данные верны</h2>
            <div class="flex flex-col justify-start content-start mt-3 md:mt-8">
              <div v-if="additionalProductsWarning && !isFilial && !isFreeCorpLeague" class="text-10px md:text-sm mb-6 md:mb-12">
                <p v-if="showingWarningMessage"><span class="text-brand-light">Внимание!</span> Счет на оплату придёт на вашу корпоративную почту.</p>
                <br>
                <p v-if="showingWarningMessage">Ссылка на игру станет доступна после оплаты счета.</p>
              </div>
                <div  class="flex flex-col md:flex-row justify-start" :class="game.game_topic_id? ' mb-6': 'mb-12'">
                    <div class="md:w-1/2">
                        <p class="title  text-10px md:text-sm">Игра</p>
                        <p class="data text-sm md:text-lg">{{gameMod.gameType}}</p>
                        <p class="bg-brand-darker text-white font-bold inline-block py-2 px-4 rounded mt-4">{{gameMod.distributionFormat}}</p>
                    </div>
                    <div v-if="true">
                        <p class="title pr-4 text-10px md:text-sm mt-3 md:mt-0">Дата и время регистрации</p>
                        <div  class="flex justify-between">
                            <div class="flex content-center">
                                <img src="@/assets/SVG/calendar-light.svg" alt="calender-light" class="w-5 h-5">
                                <p class="data text-sm md:text-lg  ml-2">{{gameMod.regDate}}</p>
                            </div>
                            <div class="flex content-center mr-10 md:mr-0">
                                <img src="@/assets/SVG/clock.svg" alt="clock" class="w-5 h-5">
                                <p class="data text-sm md:text-lg  ml-2">{{gameMod.regTime}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="game.game_topic_id" class="mb-12">
                    <p class="title  text-10px md:text-sm">Тип игры</p>
                    <p class="data text-sm md:text-lg">
                      {{gameMod.game_topic}}</p>
                </div>
                <div class="mb-6">
                    <div v-for="game in gameMod.events" :key="game.key" class="flex flex-col md:flex-row justify-start md:items-baseline mb-6">
                        <div class="md:w-1/2">
                            <p class="title pr-4 whitespace-no-wrap text-10px md:text-sm">Дата и время мероприятия</p>
                            <div class="flex justify-between">
                                <div class="flex content-center">
                                    <img src="@/assets/SVG/calendar-light.svg" alt="calender-light" class="w-5 h-5">
                                    <p class="data ml-2 text-sm md:text-lg">{{game.eventDate}}</p>
                                </div>
                                <div class="flex content-center mr-10 md:ml-10">
                                    <img src="@/assets/SVG/clock.svg" alt="clock" class="w-5 h-5">
                                    <p class="data ml-2 text-sm md:text-lg">{{game.eventTime}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 text-10px md:text-sm">
                            <p class="title">Заведение</p>
                            <p class="data text-sm md:text-lg hidden md:block ">{{game.eventPlace}}</p>
                            <p v-for="(place, idx) in mobilePlaces(game.eventPlace)" :key="idx" class="data text-sm md:text-lg  md:hidden ">{{place}}</p>
                        </div>
                    </div>
                </div>
                <div class="md:mt-12 mb-8 text-sm" v-if="offlineProducts && documentHref" >
                    <label class="flex justify-start items-center md:items-start mt-1">
                        <span class="w-8">
                            <input class="checkbox" v-model="conform"  type="checkbox">
                            <span class="checkbox-custom"></span>
                        </span>
                        <span class="px-1 pt-1 text-10px md:text-sm">
                            Я ознакомлен и согласен с
                                            <a :href="documentHref" class="text-brand-light" :class="{'disabled text-grey no-underline':isRefNotActive}" target="_blank">Лицензионным соглашением.</a><br>
                        </span>
                    </label>
                </div>
                <div class="flex justify-center md:justify-between">
                    <div class="md:flex justify-start items-center cursor-pointer hidden"
                            @click.prevent.stop="$emit('decline')">
                        <img src="@/assets/vector-left.png" alt="vector-left" class="h-4" />
                        <p class="ml-4 data text-lg">Назад</p>
                    </div>
                    <button class=" py-3  px-16 font-semibold  text-lg  rounded-full  outline-none"
                            :class="game.processing||(!conform&&offlineProducts&&documentHref) ? 'bg-additional-text text-white cursor-default' :'bg-brand-yellow hover-up text-main-text cursor-pointer'"
                            @click.prevent.stop="$emit('confirm')" :disabled="game.processing||(!conform&&offlineProducts&&documentHref)">
                        Заказать игру</button>
                </div>

            </div>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal-white.vue';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import ru from 'date-fns/locale/ru';

export default {
  name: 'ConfirmOrderModal',
  components: { Modal },
  mixins: [ModalMixin],
  props: ['game', 'gameTypes', 'places', 'isFreeCorpLeague', 'gameTypeChain'],

  created() {
    this.gameMod = this.initObject();
  },

  data() {
    return {
      Id: 1000,
      gameMod: '',
      typeId: '',
      conform: false,
      // cisCodes: ['994', '374', '7', '996', '371', '370', '373', '992', '993', '380', '998', '372'], // Телефонные коды стран СНГ
      cisCodes: ['AZN', 'AMD', 'KZT', 'KGS', 'LEU', 'RUB', 'TJS ', 'UAH', 'UZS'], // валюта СНГ
      belarusCode: 'BYN',
      testEv: [{ date: '24.10.13', time: '19.00', name: 'Maximfffffffffff gweg wfqw3 fw rberre erge5 e4geg' }, { date: '24.10.13', time: '19.00', name: 'Maxim1' }, { date: '24.10.13', time: '19.00', name: 'Maxim2' }],
    };
  },


  methods: {
    initObject() {
      const obj = {};
      const subTypeId = '';

      // getting game name
      const gameName = [];
      const distributionFormat = [];
      let currentCategories = this.gameTypes;
      this.gameTypeChain.forEach((item, index) => {
        if (index > 0) { // remove distributionFormat in gameName
          gameName.push(currentCategories[item].name);
        } else {
          distributionFormat.push(currentCategories[item].name);
        }
        currentCategories = currentCategories[item].subType.data;
      });
      obj.gameType = gameName.join(' - ');
      obj.distributionFormat = distributionFormat.join();

      obj.regDate = this.getDate(this.game.registration_at);
      obj.regTime = this.getTime(this.game.registration_at);
      obj.game_topic = '';
      if (this.game.game_topic_id) {
        if (this.typeId !== '' && subTypeId !== '' &&
            Object.keys(this.gameTypes[this.typeId].subType.data[subTypeId].topics.data).length > 0) { obj.game_topic = this.gameTypes[this.typeId].subType.data[subTypeId].topics.data[this.game.game_topic_id].name; }
        if (this.typeId !== '' && Object.keys(this.gameTypes[this.typeId].topics.data).length > 0) { obj.game_topic = this.gameTypes[this.typeId].topics.data[this.game.game_topic_id].name; }
      }
      obj.events = this.game.dates.map((item) => {
        const placeName = item.places.reduce((result, place, index) => {
          const placeName = this.places[place].name;
          result += placeName;
          return (index + 1) !== item.places.length ? result += ', ' : result;
        }, '');
        return {
          key: this.Id++,
          eventDate: this.getDate(item.played_at),
          eventTime: this.getTime(item.played_at),
          eventPlace: placeName,
        };
      });
      return obj;
    },
    getDate(date) {
      return format(parse(date), 'DD.MM.YYYY', { locale: ru });
    },
    mobilePlaces(places) {
      return places.split(', ');
    },
    getTime(date) {
      return format(parse(date), 'HH:mm', { locale: ru });
    },
  },

  computed: {
    showingWarningMessage() {
      return this.gameMod.gameType.toLowerCase().includes('корпоративная лига');
    },
    mobile() {
      return window.innerWidth < 840;
    },
    additionalProductsWarning() {
      console.dir(this.gameTypes[21]);
      return this.gameMod.gameType.toLowerCase().includes('корпоративная лига');
      // return this.gameTypes[21].id===21;
    },
    offlineProducts() {
      if (this.gameTypes[this.typeId]) {
        if (this.gameTypes[this.typeId].name.toLowerCase().includes('live') && this.gameMod.gameType.toLowerCase().includes('корп')) {
          return true;
        }
        return !this.gameTypes[this.typeId].name.toLowerCase().includes('live');
      }
      return false;
    },

    documentHref() {
      // eslint-disable-next-line no-nested-ternary
      // return this.currency === this.belarusCode ? '/corpLeagueBlr.pdf' : this.cisCodes.includes(this.currency) ? '/corpLeague.pdf' : '';
      return this.$store.getters.userInfo.documents.licence;
    },

    isRefNotActive() {
      return (this.currency !== this.belarusCode) && (!this.cisCodes.includes(this.currency));
    },
    phoneCode() {
      return this.$store.getters.cityProps.phone_code;
    },
    currency() {
      return this.$store.getters.userInfo.currency;
    },
    isFilial() {
      return this.$store.getters.userInfo.cityObj.partnership_type === 'filial';
    },
  },

};

</script>

<style scoped>

.disabled {
  pointer-events: none;
  cursor: default !important;
}

.title {
    @apply text-additional-text text-sm mb-1 font-mediumBig
}

.data {
    @apply text-lg font-semibold
}

.checkbox-custom,
  .label {
      display: inline-block;
      vertical-align: middle;
  }

 .checkbox:checked + .checkbox-custom::before {
   @apply border-brand-light;
      content: "";
      display: block;
      position: absolute;
      left: 6px;
      top: 1px;
      width: 9px;
      height: 14px;
      border-width: 0 4px 4px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
  }

  .checkbox {
      display: none;
  }
 .checkbox-custom {
      position: relative;
      width: 24px;
      height: 24px;
      border: 2px solid #ccc;
      border-radius: 4px;
  }
</style>
